import React from 'react';
import style from './style.module.scss';
import { Icon } from '../Icon';
import { AMC_NAME } from '@/constants/amc';

interface DeviceBadgeProps {
  status: string | undefined;
  tierNameClasses?: string;
}

const tierStatus = ['gold', 'platinum', 'silver', 'value', 'comprehensive'];

const Triangle = ({ className }: { className: string }) => {
  return (
    <div>
      <svg
        preserveAspectRatio="none"
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M0 24V0L16 12L0 24Z" fill="white" />
      </svg>
    </div>
  );
};

const DeviceBadge = (props: DeviceBadgeProps) => {
  const { status, tierNameClasses } = props;
  const formattedStatus =
    status?.toLowerCase() === 'comp' ? 'comprehensive' : status?.toLowerCase();

  const formattedTierName = () => {
    if (formattedStatus?.toUpperCase() === 'COMPREHENSIVE') {
      return '';
    } else if (formattedStatus?.toUpperCase() === 'VALUE') {
      return 'BASE ';
    }
    return formattedStatus?.toUpperCase() + ' ';
  };

  if (tierStatus.includes(`${formattedStatus}`)) {
    return (
      <div data-testid={status} className={`${style.tierBadge} ${style[`${formattedStatus}`]}`}>
        <div className={`${style.triangle} ${style.left}`}>
          <Triangle
            className={`${status?.toLowerCase() === 'comp' ? 'w-2 md:w-2.5' : 'w-3 md:w-3.5'}`}
          />
        </div>
        <p className={`${tierNameClasses} w-max font-primary`}>
          {AMC_NAME} {formattedTierName()}
        </p>
        <div className={`${style.triangle} ${style.right}`}>
          <Triangle
            className={`${status?.toLowerCase() === 'comp' ? 'w-2 md:w-2.5' : 'w-3 md:w-3.5'}`}
          />
        </div>
      </div>
    );
  } else if (formattedStatus === 'in warranty') {
    return (
      <div
        data-testid={status}
        className="self-start items-center flex py-0.5 pl-[0.625rem] pr-[0.6875rem] rounded-[1.25rem] gap-s2 md:gap-1.5 bg-[#66BD50]"
      >
        <p className="font-medium text-xs w-max text-white leading-[1.125rem]">{status}</p>
      </div>
    );
  } else if (formattedStatus) {
    return (
      <div
        data-testid={status}
        className="self-start items-center flex py-[0.3125rem] px-[0.5625rem]  md:pl-[0.625rem] md:pt-1.5 md:pb-[0.3125rem] md:pr-[0.6875rem] rounded-[1.25rem] gap-s2 md:gap-1.5 bg-[#EF934D]"
      >
        <p className="font-medium text-[0.625rem] leading-[0.9375rem] md:text-xs w-max text-white md:leading-[1.125rem]">
          {status}
        </p>
      </div>
    );
  } else {
    return <></>;
  }
};

export default DeviceBadge;
